import { fromJS } from 'immutable'
import { AdminWelcomeEmail } from 'store/records/adminWelcomeEmail'
import * as types from './actionTypes'

export const initialState = fromJS({
  data: new AdminWelcomeEmail(),
  pending: {
    get: false,
    save: false,
  },
})

const activityReducer = (state = initialState, action) => {
  const { type, payload } = action
  switch (type) {
    case types.ADMIN_WELCOME_EMAIL.POST.SUCCESS:
    case types.ADMIN_WELCOME_EMAIL.PUT.SUCCESS: {
      return state.set('data', new AdminWelcomeEmail(payload.data)).setIn(['pending', 'save'], false)
    }
    case types.ADMIN_WELCOME_EMAIL.GET.SUCCESS: {
      return state.set('data', new AdminWelcomeEmail(payload.data)).setIn(['pending', 'get'], false)
    }
    case types.ADMIN_WELCOME_EMAIL.GET.REQUEST: {
      return state.setIn(['pending', 'get'], true)
    }
    case types.ADMIN_WELCOME_EMAIL.PUT.REQUEST:
    case types.ADMIN_WELCOME_EMAIL.POST.REQUEST: {
      return state.setIn(['pending', 'save'], true)
    }
    case types.ADMIN_WELCOME_EMAIL.GET.FAIL: {
      return state.setIn(['pending', 'get'], false)
    }
    case types.ADMIN_WELCOME_EMAIL.PUT.FAIL:
    case types.ADMIN_WELCOME_EMAIL.POST.FAIL: {
      return state.setIn(['pending', 'save'], false)
    }
    default:
      return state
  }
}

export default activityReducer
